import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedAdminRoute({ children }) {
    const { user } = useAuth();
    const location = useLocation();

    if (user === null) {
        return (
            <div
                className="min-h-screen flex items-center justify-center"
                data-testid="admin-loading"
            >
                <Loader2 size={28} className="animate-spin text-lpl-primary-deep" />
            </div>
        );
    }
    if (!user || user.role !== "admin") {
        return <Navigate to="/admin/login" replace state={{ from: location }} />;
    }
    return children;
}
